import { BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS } from 'stash/store/bootstrapActions';

type FundingSource = Record<string, unknown>;

type FundingSourceAction = {
	type: string;
	response?: {
		funding_sources?: FundingSource[];
		funding_source?: FundingSource;
	};
};

const funding_source = (
	state: FundingSource[] = [],
	action: FundingSourceAction
): FundingSource[] => {
	switch (action.type) {
		case BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS:
			return action.response?.funding_sources ?? state;
		default:
			return state;
	}
};

export default funding_source;
